import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/16/solid';
import { ConnectButton } from '@rainbow-me/rainbowkit';
import { disconnect } from '@wagmi/core';
import { useAccount } from 'wagmi';
import { config } from '../../providers/config';
import IconSvg from './ui/IconSvg';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { useHttp } from 'src/hooks';
import { Tooltip } from 'react-tooltip';

export const ConnectWallet = () => {
  const { address } = useAccount();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const { sendRequest } = useHttp();
  const [user, setUser] = useState<any>(null);

  const handleSignOut = async () => {
    console.log('disconnecting');
    await disconnect(config);
    localStorage.removeItem('jwt')
    navigate('/')
  };

  const connectDiscord = () => {
    if (address) {
      sendRequest(
        {
          url: `auth/discord/login/${address}`,
          method: 'GET',
        },
        (data: any) => {
          if (data?.url) {
            window.open(data.url, '_blank');
          }
        },
      );
    }
  };

  const connectTwitter = () => {
    if (address) {
      sendRequest(
        {
          url: `twitter/login/${address}`,
          method: 'GET',
        },
        (data: any) => {
          if (data) {
            window.open(data, '_blank');
          }
        },
      );
    }
  };

  //temporary endpoint for user creation
  const createUser = (walletAddress: string) => {
    sendRequest(
      {
        url: `user/create/${walletAddress}`,
        method: 'POST',
      },
      (data: any) => {
        console.log(data);
      },
    );
  };
  //temporary endpoint to get UserData

  const getUserInfo = (walletAddress: string) => {
    sendRequest(
      {
        url: `user/user-info/${walletAddress}`,
      },
      (data: any) => {
        setUser(data);

        console.log(data, ' this is userf infno F  ');
      },
    );
  };
  const [tooltipContent, setTooltipContent] = useState('Copy');

  const handleCopy = async () => {
    if (address) {
      await navigator.clipboard.writeText(address);
      setTooltipContent('Copied');

      setTimeout(() => {
        setTooltipContent('Copy');
      }, 3000);
    }
  };
  useEffect(() => {
    if (address) {
      createUser(address);
      getUserInfo(address);
    }
  }, [address]);
  return (
    <ConnectButton.Custom>
      {({ account, chain, openConnectModal, openChainModal, mounted }) => {
        const ready = mounted;
        const connected = ready && account && chain;

        useEffect(() => {
          if (!connected && location.pathname === '/openbox/qiibee') {
            console.log('Current route:', location.pathname);
            openConnectModal();
          }
        }, [connected, location.pathname]);

        return (
          <div
            {...(!ready && {
              'aria-hidden': true,
              'style': {
                opacity: 0,
                pointerEvents: 'none',
                userSelect: 'none',
                zIndex: 100,
              },
            })}
          >
            {!connected ? (
              <div
                className="flex items-center px-4 py-2 space-x-3 rounded-md cursor-pointer animate-fadeInUp bg-grayscale-800"
                onClick={() => openConnectModal()}
              >
                <p className="text-base font-semibold text-center text-grayscale-200 font-jetbrains">
                  Connect Wallet
                </p>
                <ChevronDownIcon className="w-5 h-5 text-grayscale-600" />
              </div>
            ) : chain.unsupported ? (
              <div
                onClick={openChainModal}
                className="px-4 py-2 text-base font-semibold text-center rounded-md cursor-pointer animate-fadeInUp bg-grayscale-800 text-grayscale-200 font-jetbrains"
              >
                Wrong network
              </div>
            ) : (
              <Menu as="div" className="relative inline-block text-left">
                {/* Set the open state on menu and handle onClose */}
                <MenuButton
                  className="flex items-center py-2 text-base font-semibold rounded-md cursor-pointer text-grayscale-200"
                  onClick={() => setIsMenuOpen(!isMenuOpen)} // Toggle menu open state
                >
                  {address?.substring(0, 6)}...{address?.substring(address.length - 4)}
                  {isMenuOpen ? (
                    <IconSvg icon="arrowUpM" className="w-5 h-5 ml-2 text-brand-primary-light" />
                  ) : (
                    <IconSvg icon="arrowDownM" className="w-5 h-5 ml-2 text-brand-primary-light" />
                  )}
                </MenuButton>

                {/* Handling Menu open/close state */}
                <MenuItems
                  className="absolute right-0 z-50 w-64 p-5 mt-2 origin-top-right rounded-md shadow-lg bg-grayscale-800 ring-1 ring-white ring-opacity-5 focus:outline-none"
                  onClick={() => setIsMenuOpen(false)} // Close menu on item click
                  // onMouseLeave={() => setIsMenuOpen(false)} // Close menu on mouse leave
                >
                  <div className="flex items-center pb-4 border-b-2 border-gray-700">
                    <div className="w-10 h-10 mr-3 bg-purple-600 rounded-full"></div>

                    <div className="flex items-center">
                      <p className="text-base font-normal leading-5 text-grayscale-100 font-jetbrains">
                        {address?.substring(0, 6)}...{address?.substring(address.length - 4)}
                      </p>

                      <button
                        className="ml-2"
                        data-tooltip-id={`tooltip-copy`}
                        onClick={handleCopy}
                      >
                        <IconSvg icon="copyS" className="text-grayscale-400" />
                      </button>

                      <Tooltip
                        id={`tooltip-copy`}
                        content={tooltipContent}
                        place="top"
                        offset={10}
                        className={`!py-1.5 !px-3 !text-sm rounded !bg-grayscale-100 !z-50 !text-gray-900`}
                      />
                    </div>
                  </div>
                  <MenuItem>
                    {({ active }) => (
                      <button
                        onClick={() => navigate('/profile/keys')}
                        className={`${
                          active ? '' : ''
                        } group flex w-full items-center gap-2 py-2 pt-4 font-jetbrains font-normal text-xs text-gray-300`}
                      >
                        <IconSvg icon="userS" className="text-grayscale-200" />
                        View profile
                      </button>
                    )}
                  </MenuItem>
                  {/*<MenuItem>*/}
                  {/*  {({ active }) => {*/}
                  {/*    const isConnected = user?.discord !== null;*/}

                  {/*    return (*/}
                  {/*      <button*/}
                  {/*        onClick={!isConnected ? connectDiscord : undefined}*/}
                  {/*        className={`${*/}
                  {/*          active ? '' : ''*/}
                  {/*        } group flex w-full items-center justify-between gap-2 py-2 font-jetbrains font-normal text-xs text-gray-300 ${*/}
                  {/*          isConnected ? 'cursor-default opacity-50' : 'cursor-pointer'*/}
                  {/*        }`}*/}
                  {/*        disabled={isConnected}*/}
                  {/*      >*/}
                  {/*        <div className="flex items-center space-x-2">*/}
                  {/*          <IconSvg icon="discordS" className="text-grayscale-200" />*/}
                  {/*          <p>Connect Discord</p>*/}
                  {/*        </div>*/}
                  {/*         Conditional rendering for the span */}
                  {/*        {isConnected ? (*/}
                  {/*          <IconSvg icon="checkmarkConnected" className="text-grayscale-200" />*/}
                  {/*        ) : (*/}
                  {/*          <span className="text-xs font-semibold font-jetbrains text-grayscale-200">*/}
                  {/*            +50 ⭐*/}
                  {/*          </span>*/}
                  {/*        )}*/}
                  {/*      </button>*/}
                  {/*    );*/}
                  {/*  }}*/}
                  {/*</MenuItem>*/}

                  {/*<MenuItem>*/}
                  {/*  {({ active }) => {*/}
                  {/*    const isTwitterConnected = user?.twitter !== null;*/}

                  {/*    return (*/}
                  {/*      <button*/}
                  {/*        onClick={!isTwitterConnected ? connectTwitter : undefined}*/}
                  {/*        className={`${*/}
                  {/*          active ? '' : ''*/}
                  {/*        } group flex w-full items-center justify-between gap-2 py-2 font-jetbrains font-normal text-xs text-gray-300 ${*/}
                  {/*          isTwitterConnected ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'*/}
                  {/*        }`}*/}
                  {/*        disabled={isTwitterConnected}*/}
                  {/*      >*/}
                  {/*        <div className="flex items-center space-x-2">*/}
                  {/*          <IconSvg icon="twitterS" className="text-grayscale-200" />*/}
                  {/*          <p>Connect Twitter</p>*/}
                  {/*        </div>*/}
                  {/*         Conditional rendering for the span */}
                  {/*        {isTwitterConnected ? (*/}
                  {/*          <IconSvg icon="checkmarkConnected" className="text-grayscale-200" />*/}
                  {/*        ) : (*/}
                  {/*          <span className="text-xs font-semibold font-jetbrains text-grayscale-200">*/}
                  {/*            +60 ⭐*/}
                  {/*          </span>*/}
                  {/*        )}*/}
                  {/*      </button>*/}
                  {/*    );*/}
                  {/*  }}*/}
                  {/*</MenuItem>*/}

                  {/* <MenuItem>
                    {({ active }) => (
                      <button
                        className={`${
                          active ? '' : ''
                        } group flex w-full items-center gap-2 py-2 font-jetbrains font-normal text-xs text-gray-300`}
                      >
                        <div className="flex items-center space-x-2">
                          <IconSvg icon="settingsS" className="text-grayscale-200" />
                          <p>Profile settings</p>
                        </div>
                      </button>
                    )}
                  </MenuItem> */}
                  <MenuItem>
                    {({ active }) => (
                      <button
                        onClick={handleSignOut}
                        className={`${
                          active ? '' : ''
                        } group flex w-full items-center gap-2 py-2 font-jetbrains font-normal text-xs text-gray-300`}
                      >
                        <div className="flex items-center space-x-2">
                          <IconSvg icon="logoutS" className="text-grayscale-200" />
                          <p>Log out</p>
                        </div>
                      </button>
                    )}
                  </MenuItem>
                </MenuItems>
              </Menu>
            )}
          </div>
        );
      }}
    </ConnectButton.Custom>
  );
};
